import { render, staticRenderFns } from "./PreviewImageSidebar.vue?vue&type=template&id=576e7b4d&scoped=true&"
import script from "./PreviewImageSidebar.vue?vue&type=script&lang=ts&"
export * from "./PreviewImageSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewImageSidebar.vue?vue&type=style&index=0&id=576e7b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576e7b4d",
  null
  
)

export default component.exports